import { render, staticRenderFns } from "./App.vue?vue&type=template&id=5b9a5acb&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "@/styles/main.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./App.vue?vue&type=style&index=1&id=5b9a5acb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9a5acb",
  null
  
)

export default component.exports